import { AddressTypeEnum } from './AddressTypeEnum'
import { StatusEnum } from '../base/StatusEnum'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Gps } from './Gps'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('AddressInput')
export class Address {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('addr') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  city: string

  @Field(() => String)
  @Prop({ type: String })
  company: string

  @Field(() => String)
  @Prop({ type: String })
  country: string

  @Field(() => String)
  @Prop({ type: String })
  fullAddress: string

  @Field(() => Gps)
  @Prop({ type: Gps })
  gps: Gps

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => String)
  @Prop({ type: String })
  state: string

  @Field(() => String)
  @Prop({ type: String, default: StatusEnum.Active })
  status: StatusEnum

  @Field(() => String)
  @Prop({ type: String })
  street1: string

  @Field(() => String)
  @Prop({ type: String })
  street2: string

  @Field(() => String)
  @Prop({ type: String })
  street3: string

  @Field(() => [String])
  @Prop({ type: [String] })
  tags: string[]

  @Field(() => String)
  @Prop({ type: String, default: AddressTypeEnum.personal })
  type: AddressTypeEnum

  @Field(() => String)
  @Prop({ type: String })
  zip: string

  /**
   * This the Attention/person name to contact to
   */
  @Field(() => String)
  @Prop({ type: String })
  name: string

  /**
   * This is phone number, it is used for billing information
   * This is an optional field
   */
  @Field(() => String)
  @Prop({ type: String })
  phone: string

  /**
   * Can used on shipping information
   */
  @Field(() => String)
  @Prop({ type: Boolean })
  addressResidentialIndicator: boolean

  /**
   * This email field can be used for billing or shipping information
   * This is optional field anyway
   */
  @Field(() => String)
  @Prop({ type: String })
  email: string

  /**
   * The current timezone for the address, this is usefull on shipping
   * But still an optional field here
   */
  @Field(() => String)
  @Prop({ type: String })
  timeZone: string
}
